import Storage, { MODE } from './Storage';
import { TTLS, KEYS } from './constants';

const storageCache = new Storage({ ttl: TTLS.WITHOUT, mode: MODE.STORAGE });
const sessionCache = new Storage({ ttl: TTLS.WITHOUT, mode: MODE.SESSION });

export { TTLS, KEYS, sessionCache, storageCache };

export default storageCache;
